import { Component, Injector, ViewChild } from '@angular/core';
import { ImpersonationService } from '@app/admin/users/impersonation.service';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
  SendOutstandingNotificationInput,
  StaffsAndUsersServiceProxy,
} from '@shared/service-proxies/service-proxies';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'outstandingItemsModal',
  templateUrl: './outstanding-items-modal.component.html',
  styleUrls: ['outstanding-items-modal.component.less'],
})
export class OutstandingItemsModalComponent extends AppComponentBase {
  @ViewChild('modal', { static: true }) modal: ModalDirective;

  options: any;

  private userId: string;

  constructor(
    injector: Injector,
    private _staffsAndUsersServiceProxy: StaffsAndUsersServiceProxy,
    private _impersonationService: ImpersonationService
  ) {
    super(injector);
  }

  show(options: any): void {
    this.options = options;
    this.modal.show();

    this.userId = this.options?.isRoleChange
      ? this.options?.staff?.userId
      : this.options?.staff?.staffId;
  }

  close(): void {
    this.modal.hide();
  }

  askUserTocloseItems(): void {
    const body = new SendOutstandingNotificationInput();
    body.staffId = Number(this.userId);

    this._staffsAndUsersServiceProxy
      .sendOutstandingItemsNotificationBeforeRemovingUser(body)
      .pipe(finalize(() => this.modal.hide()))
      .subscribe(
        () => this.notify.success(this.l('SuccessfullySendEmail')),
        () => this.notify.error(this.l('CannotSentEmail'))
      );
  }

  loginAsUser(): void {
    this._impersonationService.impersonate(
      Number(this.options?.staff?.userId),
      this.appSession.tenantId
    );
  }
}
